import { render, staticRenderFns } from "./Esqueceu_Senha.vue?vue&type=template&id=2006bde8&scoped=true&"
import script from "./Esqueceu_Senha.vue?vue&type=script&lang=js&"
export * from "./Esqueceu_Senha.vue?vue&type=script&lang=js&"
import style0 from "./Esqueceu_Senha.vue?vue&type=style&index=0&id=2006bde8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006bde8",
  null
  
)

export default component.exports